<template>
  <main class="main profile-page sell-offers-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="tab-list">
            <router-link to="/profile" class="item">Profile</router-link>
            <router-link to="/orders" class="item">Orders</router-link>
            <router-link v-if='isOfferEnabled' to="/offers" class="item">My Offers</router-link>
            <div @click="$parent.logout" class="item">Log Out</div>
          </div>
          <div class="profile-table" v-if="$parent.orderHistory">
            <div class="profile-table-wrapper profile-form-wrapper">
              <div class="title small">Orders</div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Date/time</td>
                      <td>Skin name</td>
                      <td>Total</td>
                      <td>Status</td>
                      <!-- <td>Details</td> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item,i) in $parent.orderHistory" :key="i">
                      <td>{{item.id}}</td>
                      <td>{{item.created_at_foramtted}}</td>
                      <td>{{item.title}}</td>
                      <td>{{item.sum}} {{$parent.currency}}</td>
                      <td>{{item.status}}</td>
                      <!-- <td>
                        <a class="offer-modal-open" @click="$emit('openOfferDetailsModal', item)">View</a>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pagination" id="pagination"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'Orders',
  props: ['isOfferEnabled'],
  components: {
  },
  data: function() {
    return {
      
    }
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit('openOfferDetailsModal')
    }
  }
}
</script>